import { render, staticRenderFns } from "./CashClosing.vue?vue&type=template&id=488a264e&scoped=true"
import script from "./CashClosing.vue?vue&type=script&lang=js"
export * from "./CashClosing.vue?vue&type=script&lang=js"
import style0 from "./CashClosing.vue?vue&type=style&index=0&id=488a264e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a264e",
  null
  
)

export default component.exports